import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DomainsModel } from 'src/app/models/domains.model';
import { WindorefService } from 'src/app/services/window/windoref.service';
import { environment } from 'src/environments/environment';

const domains: Array<DomainsModel> = [
  {
    domain: 'landings-test.trillonario.com',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    domainRedirect: 'https://beta-test.trillonario.com',
    papTrack: 1,
    language: 'default',
    upsell: true,
    design: 'new',
    parentSiteId: 1
  },
  {
    domain: 'landings-stage.trillonario.com',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    domainRedirect: 'https://beta-stage.trillonario.com',
    papTrack: 1,
    language: 'default',
    upsell: true,
    design: 'new',
    parentSiteId: 1
  },
  {
    domain: 'landings.trillonario.com',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    domainRedirect: 'https://www.trillonario.com',
    papTrack: 1,
    language: 'default',
    upsell: true,
    design: 'new',
    parentSiteId: 1
  },
  {
    domain: 'landings.trillonario.co.cr',
    url: 'https://affiliatetrack.trillonario.co.cr/scripts/track.js',
    domainRedirect: 'https://www.trillonario.co.cr',
    papTrack: 1,
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1089
  },
  {
    domain: 'landings.trillonario.co',
    url: 'https://affiliatetrack.trillonario.co/scripts/track.js',
    domainRedirect: 'https://www.trillonario.co',
    papTrack: 1,
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1
  },
  {
    domain: 'landings.trillonario.cr',
    url: 'https://affiliatetrack.trillonario.cr/scripts/track.js',
    domainRedirect: 'https://www.trillonario.cr',
    papTrack: 1,
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1090
  },
  {
    domain: 'pt-landings-test.trillonario.com',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    domainRedirect: 'https://beta-test.trillonario.com',
    papTrack: 1,
    language: 'pt-la',
    ISOLanguage: 'pt',
    design: 'new',
    upsell: false,
    parentSiteId: 992
  },
  {
    domain: 'pt-landings-stage.trillonario.com',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://beta-stage.trillonario.com',
    language: 'pt-la',
    ISOLanguage: 'pt',
    design: 'new',
    upsell: false,
    parentSiteId: 992
  },
  {
    domain: 'pt-landings.trillonario.com',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://www.trilhardario.com',
    language: 'pt-la',
    ISOLanguage: 'pt',
    design: 'new',
    upsell: false,
    parentSiteId: 992
  },
  {
    domain: 'landings-test.trilhardario.com',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    domainRedirect: 'https://beta-test.trillonario.com',
    papTrack: 1,
    language: 'pt-la',
    ISOLanguage: 'pt',
    design: 'new',
    upsell: false,
    parentSiteId: 992
  },
  {
    domain: 'landings-stage.trilhardario.com',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://beta-stage.trillonario.com',
    language: 'pt-la',
    ISOLanguage: 'pt',
    design: 'new',
    upsell: false,
    parentSiteId: 992
  },
  {
    domain: 'landings.trilhardario.com',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://www.trilhardario.com',
    language: 'pt-la',
    ISOLanguage: 'pt',
    design: 'new',
    upsell: false,
    parentSiteId: 992
  },
  {
    domain: 'ar-landings-test.trillonario.net',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    domainRedirect: 'https://beta-test.trillonario.com',
    papTrack: 1,
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1077
  },
  {
    domain: 'ar-landings-stage.trillonario.net',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://beta-stage.trillonario.com',
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1077
  },
  {
    domain: 'ar-landings.trillonario.net',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://ar.trillonario.net',
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1077
  },
  {
    domain: 'co-landings-test.trillonario.net',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    domainRedirect: 'https://xxxx.trillonarios.com',
    papTrack: 1,
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1076
  },
  {
    domain: 'co-landings-stage.trillonario.com',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://xxxx.trillonarios.com',
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1076
  },
  {
    domain: 'co-landings.trillonario.net',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://www.trillonario.co',
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1076
  },
  {
    domain: 'landings-test.trillonario.com.mx',
    url: 'https://affiliatetrack.trillonario.com.mx/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://beta-test.trillonario.com',
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1015
  },
  {
    domain: 'landings-stage.trillonario.com.mx',
    url: 'https://affiliatetrack.trillonario.com.mx/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://beta-test.trillonario.com',
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1015
  },
  {
    domain: 'landings.trillonario.com.mx',
    url: 'https://affiliatetrack.trillonario.com.mx/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://www.trillonario.com.mx',
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: true,
    design: 'new',
    parentSiteId: 1015
  },
  {
    domain: 'landings-test.wintrillions.com',
    url: 'https://affiliatetrack.wintrillions.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://beta-test.trillonario.com',
    language: 'en-us',
    ISOLanguage: 'en',
    upsell: true,
    design: 'new',
    parentSiteId: 1000
  },
  {
    domain: 'landings-stage.wintrillions.com',
    url: 'https://affiliatetrack.wintrillions.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://beta-stage.trillonario.com',
    language: 'en-us',
    ISOLanguage: 'en',
    design: 'new',
    upsell: true,
    parentSiteId: 1000
  },
  {
    domain: 'landings.wintrillions.com',
    url: 'https://affiliatetrack.wintrillions.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://www.wintrillions.com',
    language: 'en-us',
    ISOLanguage: 'en',
    design: 'new',
    upsell: true,
    parentSiteId: 1000
  },
  {
    domain: 'wintrillions.co.uk',
    url: 'https://affiliatetrack.wintrillions.co.uk/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://beta-test.trillonario.com',
    language: 'en-us',
    ISOLanguage: 'en',
    upsell: true,
    design: 'new',
    parentSiteId: 1000
  },
  {
    domain: 'landings-test.lottokings.com',
    url: 'https://affiliatetrack.lottokings.com/scripts/track.js',
    papTrack: 2,
    domainRedirect: 'https://beta-test.lottokings.com',
    language: 'default',
    upsell: false,
    design: 'new',
    parentSiteId: 1061
  },
  {
    domain: 'landings-stage.lottokings.com',
    url: 'https://affiliatetrack.lottokings.com/scripts/track.js',
    papTrack: 2,
    domainRedirect: 'https://beta-stage.lottokings.com',
    language: 'default',
    upsell: false,
    design: 'new',
    parentSiteId: 1061
  },
  {
    domain: 'landings.lottokings.com',
    url: 'https://affiliatetrack.lottokings.com/scripts/track.js',
    papTrack: 2,
    domainRedirect: 'https://www.lottokings.com',
    language: 'default',
    upsell: false,
    design: 'new',
    parentSiteId: 1061
  },
  {
    domain: 'es-landings-test.lottokings.com',
    url: 'https://affiliatetrack.lottokings.com/scripts/track.js',
    papTrack: 2,
    domainRedirect: 'https://beta-test.lottokings.com',
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: false,
    design: 'new',
    parentSiteId: 1061
  },
  {
    domain: 'es-landings-stage.lottokings.com',
    url: 'https://affiliatetrack.lottokings.com/scripts/track.js',
    papTrack: 2,
    domainRedirect: 'https://beta-stage.lottokings.com',
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: false,
    design: 'new',
    parentSiteId: 1061
  },
  {
    domain: 'es-landings.lottokings.com',
    url: 'https://affiliatetrack.lottokings.com/scripts/track.js',
    papTrack: 2,
    domainRedirect: 'https://es.lottokings.com',
    language: 'es-la',
    ISOLanguage: 'es',
    upsell: false,
    design: 'new',
    parentSiteId: 1061
  },
  {
    domain: 'landings-test.lotosena.com',
    url: 'https://affiliatetrack.lottokings.com/scripts/track.js',
    papTrack: 2,
    domainRedirect: 'https://beta-test.lottokings.com',
    language: 'pt-la',
    ISOLanguage: 'pt',
    upsell: false,
    design: 'new',
    parentSiteId: 1061
  },
  {
    domain: 'landings-stage.lotosena.com',
    url: 'https://affiliatetrack.lottokings.com/scripts/track.js',
    papTrack: 2,
    domainRedirect: 'https://beta-stage.lottokings.com',
    language: 'pt-la',
    ISOLanguage: 'pt',
    upsell: false,
    design: 'new',
    parentSiteId: 1061
  },
  {
    domain: 'landings.lotosena.com',
    url: 'https://affiliatetrack.lottokings.com/scripts/track.js',
    papTrack: 2,
    domainRedirect: 'https://www.lotosena.com',
    language: 'pt-la',
    ISOLanguage: 'pt',
    upsell: false,
    design: 'new',
    parentSiteId: 1061
  },
  {
    domain: 'localhost',
    url: 'https://affiliatetrack.trillonario.com/scripts/track.js',
    papTrack: 1,
    domainRedirect: 'https://beta-test.trillonario.com',
    language: 'pt-la',
    ISOLanguage: 'pt',
    upsell: true,
    design: 'new',
    parentSiteId: 1
  }
];

@Injectable({
  providedIn: 'root'
})
export class DomainService {
  constructor(private winRef: WindorefService) {}

  getCurrentDomain(customDomain = null): DomainsModel {
    var currentDomain: DomainsModel;
    if (customDomain == null) {
      let path = this.winRef.getNativeWindow().location.hostname.replace('https://www.', '').replace('http://www.', '').replace('www.', '');
      currentDomain = domains.find((findDomain) => findDomain.domain === path);
    } else {
      currentDomain = domains.find((findDomain) => findDomain.domain === customDomain);
    }
    return currentDomain;
  }

  verifyDomain(whoIsDomain): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      let currentDomain = this.getCurrentDomain();
      let isProd: boolean = environment.production;
      let domain = domains.find((findDomain) => findDomain.domainRedirect === whoIsDomain);
      if (domain && isProd) {
        if (domain.domainRedirect !== currentDomain.domainRedirect) {
          let window = this.winRef.getNativeWindow();
          let newRedirect = `https://${domain.domain}${window.location.pathname}${window.location.search}`;
          window.location.href = `${newRedirect}`;
          reject();
        }
      }
      resolve();
    });
  }
}
